import { IconButton } from '@launchpad-ui/components';

import styles from './CodeEditorRetryFallback.module.css';

export const CodeEditorRetryFallback = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => (
  <div className={styles.fallback}>
    <div className={styles.retry}>
      Failed to load code editor.{' '}
      <IconButton
        onPress={resetErrorBoundary}
        aria-label="retry loading code editor"
        name="Retry loading code editor"
        size="small"
        variant="minimal"
        icon="sync"
      />
    </div>
  </div>
);
